export const DEFAULT_PAGINATION = {
  page: 1,
  limit: 10,
}

export const PAGINATION_OPTIONS = [10, 20, 50, 100, 250]

export const PAGINATION_CLASSES = {
  CONTAINER: 'pagination',
  PREVIOUS_LINK: 'pagination__link',
  NEXT_LINK: 'pagination__link',
  DISABLED: 'pagination__link--disabled',
  ACTIVE: 'pagination__link--active',
  PREVIOUS_LABEL: '<',
  NEXT_LABEL: '>',
}

